import React, { Component } from "react";
// import { } from "@material-ui/core";
import { Link } from "react-router-dom";
import { FormatAlignJustify, Close } from "@material-ui/icons";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      buttonClicked: false,
    };
  }
  
  navShow = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.setState({ show: true, buttonClicked: true});
      // simple work flow to show the nav on click. - works like a charm :)
      let documentNav = document.querySelector(".navbar").style.display = "flex";
      // console.log(documentNav);
      return documentNav;
    }, 300);   
  }
  onNavHide = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.setState({show: false, buttonClicked: false});
      let navToHide = document.querySelector(".navbar").style.display = "none";
      
      return navToHide;
      
    }, 500);
  }
  // works like a charm
  checkResponsiveWidth = () => {
    // width to compare against for function scope to work approppriately
    // get navbutton and check if it was clicked

        setInterval(() => {
          let navButton = document.querySelector(".toggleNav");
          let navButtonState = this.state.buttonClicked;

          if(navButton){
            // console.log(navButton);
            // console.log("NavButton state is : " + navButtonState);
            // get routerview container housing chnging containers and act accordingly
            let documentContainer = document.querySelector(".router-view");
            // console.log(documentContainer);
            // add event listener to work with
            documentContainer.addEventListener("click", (event)=>{
              event.preventDefault();
              // console.log(event);
              if(event.isTrusted === true) {
                return document.querySelector(".navbar").style.display = "none";
              };
            });

            let minWidth = Number(621);
            let innerWidth = window.innerWidth;
            // console.log(innerWidth);
            // console.log("checking if the min-width of :"+ innerWidth + " is greater or smaller than : "+ minWidth);
            if(innerWidth <= minWidth-1 && navButtonState === false ){
              return document.querySelector(".navbar").style.display = "none";
            }
            // console.log(eventReturned);
            if( innerWidth >= minWidth) {
              // console.log("Inner Width is greater... apply more logic from " + innerWidth +" and onwards.");
              return document.querySelector(".navbar").style.display = "flex";
            }
          }
          // return innerWidth;
        }, 10);

  }

  render () {
    // console.log(this);
    return (
      <div color="inherit" className="container-nav">
        <Link className="nav-brand" to="/">
          Kompanycoder.dev
        </Link>
        
        <div className="navbar" id="navbar" show={this.state.show.toString()} onChange={this.checkResponsiveWidth()}>
          <li className="nav-item" variant="contained">
            <Link to="/about">About</Link>
          </li>
          <li className="nav-item" variant="contained">
            <Link to="/services">Services</Link>
          </li>
          <li className="nav-item">
            <Link to="/projects">Projects</Link>
          </li>
          <li className="nav-item">
            <Link to="/contact">Contact</Link>
          </li>
          <Close className="closeNav" onClick={(e)=>this.onNavHide(e)}></Close>
        </div>
        <FormatAlignJustify className="toggleNav" onClick={(e)=>this.navShow(e)} buttonclicked={this.state.buttonClicked.toString()}></FormatAlignJustify>
      </div>
    );
  }
};
export default Header;
